import ethereum from 'decentralized/ethereum.js';
import sampleRateChooser from 'engine/SampleRateChooser.js';
import {LOW_SAMPLE_RATE, LOWEST_SAMPLE_RATE} from 'constants/sample-rates.js';
import accounts from 'accounts/Accounts.js';
import MixableSequencerEngine from 'engine/mix/MixableSequencerEngine.js';

export const initSequencerEngine = (store) => {
    accounts.setEthereum(ethereum);
    ethereum.store = store;
    ethereum.crypto.store = store;
    ethereum.guilds.initGuilds();
    accounts.setStore(store);
    sampleRateChooser.setSampleRate(LOW_SAMPLE_RATE);
    let sequencerEngine = new MixableSequencerEngine(store);
    window.multiMix = true;
    window.sequencerEngine = sequencerEngine;
    sequencerEngine.ethereum = ethereum;
    return sequencerEngine;
};
 
